import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

export const selectDashboardPage = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.DashboardPageStore
  ],
  (store) => store
)
